import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../../components/tailwind/Button'
import Modal from '../../../components/tailwind/Modal'
import { Heading } from '../../../components/ui/Heading'
import trackEvents from '../../../constants/track-events'
import { useUserContext } from '../../../context'
import { trackEvent } from '../../../helpers/analytics'
import { useDiscover } from '../hooks/useDiscover'

const markdownDescriptionDE = `
Hi, ich bin **Florian** – Wirtschaftspsychologe und Mitgründer von **Aivy**. Schön, dass du da bist!

Unsere Mission:  
**Personalauswahl einfacher, objektiver und fairer gestalten – für alle Beteiligten.**

Mit **Aivy** findest du heraus, **welche Talente wirklich zu deinen Stellen passen.**  
Die **Assistenz auf der rechten Seite** begleitet dich Schritt für Schritt.
`

export default function WelcomeVideoModal({ onFinish }) {
  const videoRef = useRef(null)
  const { t } = useTranslation()
  const { activeSpace } = useUserContext()

  const { welcomeVideoOpen, setWelcomeVideoOpen } = useDiscover()
  const hasCompletedOnboarding = activeSpace?.hasCompletedOnboarding

  const handleClose = () => {
    trackEvent(trackEvents.DISCOVER_CLICK_SKIP_WELCOME_VIDEO)
    localStorage.setItem('hideWelcomeVideo', 'true')
    setWelcomeVideoOpen(false)
    if (typeof onFinish === 'function') onFinish()
  }

  // Don't show modal if onboarding is completed
  if (hasCompletedOnboarding) {
    return null
  }

  useEffect(() => {
    if (!welcomeVideoOpen && videoRef.current) {
      videoRef.current.pause()
      videoRef.current.currentTime = 0
    }
  }, [welcomeVideoOpen])

  return (
    <Modal
      open={welcomeVideoOpen}
      setOpen={setWelcomeVideoOpen}
      size='3xl'
      borderRadius='rounded-3xl'
      hideCloseButton
      disableOverlayClose
    >
      <div className='relative flex flex-col items-center justify-center py-12'>
        <span className='text-center text-xs font-bold text-primaryBlue'>
          {t('discover.welcome_video_modal.sub_title')}
        </span>

        <Heading level={1} className='mt-2'>
          {t('discover.welcome_video_modal.title')}
        </Heading>
        {/* <ReactMarkdown
          components={{
            p: ({ children }) => (
              <p className='mb-5 block text-balance text-darkBlack'>
                {children}
              </p>
            )
          }}
          className='mt-6 w-full max-w-xl text-center'
        >
          {markdownDescriptionDE}
        </ReactMarkdown> */}
        <video
          className='my-8 max-w-lg rounded-md'
          src={
            'https://aivy-assets.s3.eu-central-1.amazonaws.com/videos/Onboarding_2.mp4'
          }
          autoPlay={false}
          controls
          playsInline
          preload='metadata'
          aria-label={'Video'}
        >
          Dein Browser unterstützt das Video-Tag nicht.
        </video>

        {/* <div className='relative mt-4 h-[265px] w-[470px] overflow-hidden rounded-2xl'>
          <video
            ref={videoRef}
            width='470'
            height='265'
            className='aspect-video object-top'
          >
            <source
              src='https://aivy-assets.s3.eu-central-1.amazonaws.com/videos/onboarding.mp4'
              type='video/mp4'
            />
            {t('discover.welcome_video_modal.no_video_support')}
          </video>

          <div className='absolute bottom-0 left-0 flex h-12 w-full flex-col items-center justify-center rounded-bl-2xl rounded-br-2xl bg-[#EBF0F5] text-xs'>
            <span className='block text-xs font-bold text-darkBlack'>
              Florian
            </span>
            <p className='mt-0.5 block text-xs font-normal text-darkBlack'>
              {t('discover.welcome_video_modal.co_founder_title')}
            </p>
          </div>
        </div> */}

        {/* <button
          onClick={() => {
            trackEvent(trackEvents.DISCOVER_CLICK_PLAY_WELCOME_VIDEO)
            videoRef.current?.play()
          }}
          type='button'
          className='mb-4 mt-6 flex-row items-center justify-center rounded-full bg-primaryBlue px-4 py-2.5 text-sm font-medium text-white hover:bg-primaryBlue/70'
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 16 16'
            fill='currentColor'
            className='mr-1 inline-block size-4'
          >
            <path d='M3 3.732a1.5 1.5 0 0 1 2.305-1.265l6.706 4.267a1.5 1.5 0 0 1 0 2.531l-6.706 4.268A1.5 1.5 0 0 1 3 12.267V3.732Z' />
          </svg>
          {t('discover.welcome_video_modal.play_button')}
        </button> */}
        {/* <Button.Text
          text={t('discover.welcome_video_modal.skip_button')}
          onClick={handleClose}
        /> */}
        {/* <WelcomeVideoBackground /> */}
        <Button.PrimaryXL text='Jetzt starten' onClick={handleClose} />
      </div>
    </Modal>
  )
}
